// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const Comments = props =>
    <div className='labeled-string'>
        <span className='data-label'>
            {props.isRequired && <sup>{'*'}</sup>}<FormattedMessage id={props.label}/>
        </span>
        <textarea
            maxLength={props.charLimit}
            onChange={
                event => {

                    props.onItemChange(props.name, event.target.value);

                }}
            value={props.value}
        >
        </textarea>
    </div>;

Comments.displayName = 'Comments';
Comments.propTypes = {
    charLimit: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onItemChange: PropTypes.func.isRequired,
    value: PropTypes.string
};
Comments.defaultProps = {
    isRequired: false
};

export default Comments;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/input-fields/comments.js